(function () {
  const LATIN = /[A-Za-z][A-Za-z0-9+./'’& ,:-]*/g;

  function replaceEncodedSpaces(node) {
    if (node.nodeType === Node.TEXT_NODE && node.nodeValue && node.nodeValue.includes('&nbsp;')) {
      node.nodeValue = node.nodeValue.replace(/&nbsp;/g, ' ');
      return;
    }

    if (!node.querySelectorAll) {
      return;
    }

    node.querySelectorAll('*').forEach((el) => {
      el.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE && child.nodeValue && child.nodeValue.includes('&nbsp;')) {
          child.nodeValue = child.nodeValue.replace(/&nbsp;/g, ' ');
        }
      });
    });
  }

  function isolateLatin(root) {
    if (!root) {
      return;
    }

    replaceEncodedSpaces(root);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !/[A-Za-z]/.test(node.nodeValue)) {
          return NodeFilter.FILTER_REJECT;
        }

        if (node.parentElement && node.parentElement.closest('bdi, [dir="ltr"], code, pre, script, style')) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach((node) => {
      const text = node.nodeValue;
      LATIN.lastIndex = 0;

      if (!LATIN.test(text)) {
        return;
      }

      LATIN.lastIndex = 0;
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      let match;

      while ((match = LATIN.exec(text)) !== null) {
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }

        const bdi = document.createElement('bdi');
        bdi.setAttribute('dir', 'ltr');
        bdi.textContent = match[0];
        fragment.appendChild(bdi);
        lastIndex = LATIN.lastIndex;
      }

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      node.parentNode.replaceChild(fragment, node);
    });
  }

  function enhance() {
    document.querySelectorAll('[data-isolate-latin]').forEach((root) => {
      if (root.dataset.latinIsolated === 'true') {
        return;
      }

      isolateLatin(root);
      root.dataset.latinIsolated = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', enhance);
})();
